export default __webpack_public_path__ + "static/131-a4bbc43122f35affe5920e1393ffeb48.jpg";